import React, { useContext, useEffect, useState } from 'react';
import { Box, Divider, Text } from 'pcln-design-system';
import { Img, ListingCardWrapper } from './HotlListingCard.styles';
import Header from './components/Header/Header';
import Amenities from './components/Amenities/Amenities';
import Ratings from './components/Ratings/Ratings';
import Price from './components/Price/Price';
import { generateHotelSummary } from '../generateHotelSummary';
import analytics from '../../analytics';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { transformSOPQName } from '../../utils';
const HotelListingCard = ({
  listingProps,
  hotel,
  otherOptions
}) => {
  var _a;
  const [summary, setSummary] = useState('');
  const [hasSummaryError, setHasSummaryError] = useState(false);
  const [isSummaryLoading, setSummaryIsLoading] = useState(false);
  const {
    imageSrc,
    headerText,
    amenitiesList,
    ratingsProps,
    priceProps
  } = listingProps;
  const {
    setiValues,
    fetchRequestOptions,
    prompts,
    shouldDisplayGenHotelFeature
  } = useContext(ChatbotDataContext);
  const {
    starRating,
    location,
    pclnPropertyTypeId,
    hotelType,
    description,
    ratesSummary
  } = hotel;
  const isExpressDeal = hotelType === 'SOPQ';
  const isCardsWithSummary = setiValues.cardsLayoutSetiValue === 'CARROUSSEL_WITH_AI_SUMMARY';
  const isCardWithoutSummary = setiValues.cardsLayoutSetiValue === 'CARROUSSEL_NO_AI_SUMMARY';
  const transformSopqNameArgs = {
    starRating,
    location,
    pclnPropertyTypeId
  };
  const shouldDisplayFeatureSummary = shouldDisplayGenHotelFeature && summary && !hasSummaryError;
  const propertyName = isExpressDeal && !hotel.name ? transformSOPQName(transformSopqNameArgs) : hotel.name;
  const detailURL = `/relax/at/${isExpressDeal ? `express/${(_a = hotel.location) === null || _a === void 0 ? void 0 : _a.cityId}/${hotel.pclnId}` : hotel.hotelId}/from/${hotel === null || hotel === void 0 ? void 0 : hotel['check-in']}/to/${hotel === null || hotel === void 0 ? void 0 : hotel['check-out']}/rooms/${hotel.rooms}/adults/${hotel === null || hotel === void 0 ? void 0 : hotel['adult-occ']}`;
  const {
    priceDisplayRegulation,
    minCurrencyCodeSymbol,
    nightlyRateIncludingTaxesAndFees,
    grandTotal,
    minPrice
  } = ratesSummary !== null && ratesSummary !== void 0 ? ratesSummary : {};
  const showHotelPrice = priceDisplayRegulation === 'TOTAL_PRICE_PROMINENT' ? minCurrencyCodeSymbol && !isNaN(nightlyRateIncludingTaxesAndFees) && !isNaN(grandTotal) : minCurrencyCodeSymbol && !isNaN(minPrice) && !isNaN(grandTotal);
  useEffect(() => {
    var _a, _b, _c;
    if (!isExpressDeal && shouldDisplayGenHotelFeature) {
      generateHotelSummary({
        prompts,
        source: 'newHotelListingCard',
        fetchRequestOptions,
        hotelDetail: {
          hotelName: propertyName,
          description,
          starRating,
          hotelFeatures: (_b = (_a = hotel.hotelFeatures) === null || _a === void 0 ? void 0 : _a.hotelAmenities) === null || _b === void 0 ? void 0 : _b.map(feature => feature.name),
          petPolicy: (_c = hotel === null || hotel === void 0 ? void 0 : hotel.policies) === null || _c === void 0 ? void 0 : _c.petDescription
        },
        otherOptions: otherOptions === null || otherOptions === void 0 ? void 0 : otherOptions.map(({
          name,
          description,
          hotelFeatures,
          policies
        }) => {
          var _a;
          return {
            hotelName: name,
            description,
            petPolicy: policies === null || policies === void 0 ? void 0 : policies.petDescription,
            hotelFeatures: (_a = hotelFeatures === null || hotelFeatures === void 0 ? void 0 : hotelFeatures.hotelAmenities) === null || _a === void 0 ? void 0 : _a.map(feature => feature.name)
          };
        }),
        setSummaryText: summaryText => setSummary(summaryText),
        setSummaryIsLoading: isloading => {
          setSummaryIsLoading(isloading);
        },
        setHasSummaryError: hasError => setHasSummaryError(hasError)
      }).catch(err => {
        analytics.logError({
          message: 'Error generating hotel summary',
          error: JSON.stringify(err),
          loggedFrom: 'HotelDetailCard'
        });
        setHasSummaryError(true);
        setSummaryIsLoading(false);
      });
    }
  }, [propertyName]);
  return React.createElement(ListingCardWrapper, {
    borderRadius: 'xl',
    boxShadow: 'lg',
    onClick: function () {
      window.open(detailURL, '_blank');
    }
  }, React.createElement(Box, null, React.createElement(Img, {
    src: imageSrc
  })), React.createElement(Box, {
    p: 2
  }, React.createElement(Box, null, React.createElement(Header, Object.assign({}, headerText))), React.createElement(Box, null, isCardWithoutSummary ? React.createElement(Amenities, {
    amenitiesList: amenitiesList
  }) : null, isCardsWithSummary && shouldDisplayFeatureSummary ? React.createElement(Text, {
    fontSize: 0,
    lineHeight: '20px',
    pb: 1
  }, summary, isSummaryLoading ? ' ... ' : '') : null), React.createElement(Box, null, React.createElement(Ratings, Object.assign({}, ratingsProps)))), React.createElement(Divider, {
    width: 1,
    my: 1
  }), React.createElement(Box, {
    p: 0,
    px: 2
  }, showHotelPrice ? React.createElement(Price, Object.assign({}, priceProps)) : null));
};
export default HotelListingCard;